import React from 'react';
import { BuildingIcon, DeleteIcon, NakedButton } from '@weave/design-system';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';

export type OrgTabModel = {
  OrgId: string;
  Name: string;
};

export type OrgTabProps = {
  active: boolean;
  org: OrgTabModel;
  removeOrg: (orgId: string) => void;
  selectOrg: (orgId: string) => void;
};

// OrgTab mirrors LocationTab so organizations opened from the search widget show up
// alongside location tabs in the header, letting a user switch back to a
// previously-viewed org's details page or remove it from the tab list.
export const OrgTab = (props: OrgTabProps) => {
  const handleClick = () => {
    props.selectOrg(props.org.OrgId);
  };

  const removeFromList = () => {
    props.removeOrg(props.org.OrgId);
  };

  const classes = ['org-tab', ...(props.active ? ['active'] : [])].join(' ');

  return (
    <div
      className={classes}
      css={css`
        cursor: pointer;
        border-radius: 4px;
        margin: 0 2px;
        padding: 2px 8px;
        color: inherit;
        background-color: rgba(0, 106, 133, 0.15);
        border: 1px solid rgba(255, 255, 255, 0.25);
        transition: 0.2s all ease;
        min-width: max-content;

        & > a {
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 150px;
          overflow: hidden;
          display: inline-block;
          vertical-align: middle;
          padding-right: 3px;
        }

        &:hover,
        &.active {
          color: rgba(0, 0, 0, 0.5);
          background-color: rgba(255, 255, 255, 0.5);
          border-color: rgba(255, 255, 255, 0.5);
        }

        &.active {
          cursor: default;
        }
      `}
    >
      <a onClick={handleClick} title={props.org.Name}>
        <BuildingIcon
          size={12}
          css={css`
            margin-right: 4px;
            vertical-align: middle;
          `}
        />
        {props.org.Name}
      </a>
      <NakedButton
        className="delete-icon"
        css={css`
          svg {
            --size: 20px;
            height: var(--size);
            margin-left: ${theme.spacing(1)};
            width: var(--size);

            &:hover {
              transform: scale(1.2);
            }
          }
        `}
        onClick={removeFromList}
      >
        <DeleteIcon color="white" />
      </NakedButton>
    </div>
  );
};
